enum UserModuleApiSuffixModels {
  ROLES = 'roles',
  UX_ROLES = 'ux/roles',
  USER_TYPES = 'usertypes',
  UX_USER_TYPES = 'ux/usertypes',
  FEATURES = 'features',
  UX_FEATURES = 'ux/features',
  NAVIGATIONS = 'navigations',
  UX_NAVIGATIONS = 'ux/navigations',
  MODULES = 'modules',
  UX_MODULES = 'ux/modules',
  UX_AUDIT_LOGS_MODULES = 'ux/audit-log/modules',
  COUNTRIES = 'countries',
  UX_COUNTRIES = 'ux/countries',
  REGIONS = 'regions',
  UX_REGIONS = 'ux/regions',
  PROVINCES = 'provinces',
  UX_PROVINCES = 'ux/provinces',
  UX_TIERS = 'ux/tiers',
  CITIES = 'cities',
  UX_CITIES = 'ux/cities',
  UX_SUBURBS = 'ux/suburbs',
  DENY_PERMISSIONS = 'deny-permissions',
  UX_DENY_PERMISSIONS = 'ux/denypermissions',
  SPECIAL_PERMISSIONS = 'special/permission',
  UX_SPECIAL_PERMISSIONS = 'ux/specialpermissions',
  UX_SPECIAL_PERMISSIONS_STATUS = 'ux/special/permission/status',
  UX_SPECIAL_PERMISSION_STATUS = 'ux/specialpermissionstatus',
  SPECIAL_PERMISSIONS_APPROVAL = 'special/permission/approval',
  LEAVE_MANAGEMENT_USER = 'leave/permissions/user',
  LEAVE_MANAGEMENT_MANAGER = 'leave/permissions/manager',
  UX_REQUEST_TYPES = 'ux/requesttype',
  UX_LEAVE_APPLY_TYPES = 'ux/leaveapplytype',
  UX_PRIORITY = 'ux/priorities',
  USERS = 'users',
  UX_USERS = "ux/users",
  UX_USERS_SEARCH = "ux/users/search",
  UX_USERS_ALL = "ux/usersdropdown",
  SUBURB = "suburbs",
  SUBURB_DETAILS = 'suburbs/details',
  USER_LEVEL = 'userslevels',
  ROLE_SKILLSET_LIST = 'role/skillset/list',
  SKILLS_ROLE_LIST = 'skills/role/list',
  ROLE_SKILLS = 'roleSkills',
  UX_SKILLS = 'ux/skills/search',
  SKILL_MAPPINGS = 'Skill-Mappings',
  SKILLS = 'skills',
  EMPLOYEES = 'employees',
  EMPLOYEES_CREATE = 'employee',
  DEPARTMENTS = 'departments',
  UX_DEPARTMENTS = 'ux/departments',
  UX_DIVISIONS = 'ux/divisions',
  UX_REPORTINGLINES = 'ux/reportingLines',
  UX_EMPLOYEES = 'ux/employee',
  UX_SUBURB_SEARCH = 'ux/suburbs/search',
  UX_EMPLOYEEBYLOCATION = 'ux/employeebylocation',
  UX_MANAGERS = 'ux/manager',
  GROUP = "groups",
  GROUP_DETAIL = "groups-search",
  EMPLOYEE_DETAILS = 'employee/profile/details',
  UX_CONFIG_TYPES = 'ux/doa-config-types',
  UX_CONFIG_RANGES = 'ux/doa-config-ranges',
  UX_ROLES_SEARCH = 'ux/roles/search',
  UX_RoLES = 'ux/roles',
  CONFIG_LEVELS = 'doa-config-levels',
  DIVISIONS = 'divisions',
  DOA_CONFIG_APPROVALS = 'config-doa-approvals',
  Ux_dropdown_skills = 'ux/skills',
  Employee_Maintanence = 'employee/maintananceinfo',
  UX_SalesDiscount = 'ux/sales-discount',
  MODULES_NAVIGATION_FEATURES = 'module-navigation-features',
  MODULES_NAVIGATION_FEATURES_V1 = 'module-navigation-features-v1',
  UX_GROUPS = 'ux/groups',
  UserEmail_Validation = 'users/email-validate',
  TEMPLATES = 'templates',
  UX_TEMPLATE_TYPES = 'ux/template-types',
  UX_USER_STATUS = 'ux/user-status',
  UX_USER_CHANGE_STATUS = 'users/change-status',
  EMPLOYEENO_VALIDATE = 'employee-no-validation',
  UX_DISTRICT = 'ux/districts',
  UX_DIVISION_DISTRICT = 'ux/division-district',
  UX_DISTRICT_BRANCH = 'ux/district-branch',
  UX_BRANCHES = 'ux/branches',
  TAX = 'Tax',
  UX_ACTION_TYPE = 'ux/action/type',
  EVENT_LIST = 'events',
  GROUPS = "group-mappings",
  UX_AREAS = "ux/areas",
  PRIORITY = 'priorities',
  UX_LEADGROUP_DISTRICT = 'lead-groups-district',
  ACCOUNT_HOLDER_DEBTOR_DETAILS = 'account/holder/debtor-details',
  BRANCH = 'branches',
  DISTRICT_BRANCH = 'district-branch',
  SUB_BRANCH = 'sub-branches',
  BRANCHES_SUB_BRANCHES = 'branches-sub-branches',
  DISTRICT = 'districts',
  GET_EMPLOYEE_SEARCH = 'employees/search',
  SERVICE_LIST = "ux/division-user-code-services",
  FEATURE_LIST = "features",
  FEUTURE_NAVIGATION_LIST = 'ux/navigations',
  FEUTURE_FEATURES_LIST = 'features/navigation',
  ADD_FEATURE = 'featurenavigations',
  UX_ASSINGNTO = 'ux/users',
  UX_ASSINGN_TO = 'ux/tickets/assignto-by-usergroup',
  UX_MAIN_AREAS = 'ux/main-areas',
  PHYSICAL_LOCATION_LIST = 'divisions-search',
  GET_DATA_BY_ROLE_ID = "ux/reporting-roles",
  PHYSICAL_BRANCH_LIST = 'district-branch-search',
  CUSTOMER_DETAILS_ANNUAL = 'customers/debtor-address-details',
  DOA_UX_ROLE = 'ux/roles',
  SALES_API_BRANCH = 'branches',
  DOA_DEPARTMENT = 'ux/departments',
  TAX_API = 'tax',
  UX_BRANCH_MANAGER = 'ux/users/branch-managers',
  UX_BRANCH = 'ux/Branch',
  UX_TECH_AREA = 'ux/tech-area',
  UX_DIVISION = "ux/division",
  UX_DISTRICTS = 'ux/district',
  UX_CUSTOMERS = 'ux/customers',
  DIVISION_DISTRICT_DETAILS = 'division-district-details',
  DIVISION_DISTRICT = 'division-district',
  CLONE_ROLE_DROPDOWN = 'module-navigation-roles/role-cloning/roles',
  CLONED_ROLE_ACCESS = 'modulenavigationroles/access',
  MODULES_NAVIGATION_ROLES = 'modulenavigationroles',
  UX_MENU_CATEGORY = 'ux/menu-category',
  MENU_CONFIG_MENUS = 'menu',
  MENU_DETAIL = 'menu-details',
  MENU_ROLE = 'menu-role',
  MENU_ROLE_V1 = 'menu-role-v1',
  MENU_ROLE_ACCESS = 'menu-role/access',
  PHYSICAL_DIVISION = 'ux/physicallocation/divisions',
  NEW_USER_LEVEL = 'employee-role-userlevels',
  ROLE_BY_DEPT = 'employee-department-roles',
  CONFIG_LIST = 'ux/save-offer-doa-limit-config',
  MENU_SEARCH = 'menu-search',
  AD_USER_SEARCH = 'employees/ad-user-search',
  RESEND_VERIFICATION_LINK = 'employees/resend-verification-link',
  UX_REGIN_DISTRICT = 'ux/region-district',
  PAY_AT_DIVISION = 'divisions-payat',
  DIVISIONS_BRANCH = "ux/division-branches",
  UX_DEPARTMENT_ROLE_USERS = "ux/users/department-role-users",
  MENU_CHILD = 'menu-child',
  UX_SUB_BRANCHES = "ux/sub-branches",
  UX_CALL_CENTER_REGIONS = 'ux/callcenter/regions',
  UX_ALL_MOUDULES = 'ux/audit-log/modules',
  UX_ALL_SCEENS = 'ux/audit-log/screens',
  AUDIT_LOGS = 'audit-log',
  AUDIT_LOGS_EXPORT = 'audit-log-export',
  VEHICLE_CONFIGURATION = 'vehicle-configuration',
  VEHICLE_COLOR = 'vehicle-color',
  AUDIT_LOGS_PAGE = 'audit-log/page',
  AUDIT_LOGS_ROLE_BASED_ACCESS = 'audit-log/role-based-access',
  AUDIT_LOGS_ROLE_BASED_ACCESS_ENABLE_DISABLE = 'audit-log/role-based-access-enable-disable',
  AUDIT_LOGS_USERS = 'ux/audit-log/users',
  EMPLOYEE_TECHNICAL_DEPARTMENT_CHARGE_VALIDATION = 'employees-technical-department-change-validation',
  USER_DEVICE = 'user-device',
  MENU_PERMISSION = 'menu-permission',
  UX_GROUP_SELLERS = 'ux/groups/sellers',

}

enum DispatcherSiteStatuses {
  WAITING = 'Waiting',
  REQUEST_DISPATCH = 'Request Dispatch',
  ALLOCATED = 'Allocated',
  DISPATCHED = 'Dispatched',
  REQUEST_CANCEL = 'Request Cancel',
  CANCELLED = 'Cancelled',
  ARRIVED = 'Arrived',
  LONG_ON_SITE = 'LongOnSite',
  MANUALLY_DISPATCHED = 'Manually Dispatched'
}

export { UserModuleApiSuffixModels, DispatcherSiteStatuses };

